function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Section } from './Section';
import { PadMarg, Display } from './../../enhancers';
import { getElementType, getUnhandledProps } from './../../utils';
import css from './Paper.sass';

function BasePaper(props) {
  var className = props.className,
      children = props.children,
      circle = props.circle,
      rounded = props.rounded,
      shadow = props.shadow,
      zDepth = props.zDepth,
      textAlign = props.textAlign;
  var classNames = cx(css.root, circle && css.circle, rounded && css.rounded, shadow && css.shadow, zDepth && css["zDepth".concat(zDepth)], textAlign && css[textAlign], className);
  var rest = getUnhandledProps(BasePaper, props);
  var ElementType = getElementType(BasePaper, props);
  return React.createElement(ElementType, _extends({}, rest, {
    className: classNames
  }), children);
}

BasePaper.displayName = 'Paper';

var PadMargPaper = function PadMargPaper(props) {
  return React.createElement(PadMarg, _extends({
    InputComponent: BasePaper
  }, props));
};

var Paper = function Paper(props) {
  return React.createElement(Display, _extends({
    InputComponent: PadMargPaper
  }, props));
};

BasePaper.propTypes = {
  /**
   * An element type to render as (string or function)
   */
  as:
  /*#__PURE__*/
  PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Custom class name
   */
  className: PropTypes.string,

  /**
   * Paper content
   */
  children: PropTypes.node,

  /**
   * Set to true to generate a circlular paper container
   */
  circle: PropTypes.bool,

  /**
   * Paper with rounded corners
   */
  rounded: PropTypes.bool,

  /**
   * Paper with shadow
   */
  shadow: PropTypes.bool,

  /**
   * This number represents the zDepth of the paper shadow
   */
  zDepth:
  /*#__PURE__*/
  PropTypes.oneOf(['0', '1', '2', '3', '4', false]),

  /**
   * Text align
   */
  textAlign:
  /*#__PURE__*/
  PropTypes.oneOf(['left', 'right', 'center'])
};
Paper.defaultProps = {
  padding: PadMarg.size.m[0],
  circle: false,
  rounded: true,
  shadow: true,
  zDepth: false
};
Paper.Section = Section;
export { Paper };